exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item { transition: all .5s\n}[dir] .list-item { -webkit-transition: all .5s\n}\n", ""]);

// exports
